// 以下两个 import 针对 IE11打的补丁，效果不佳，暂不起用
// import '@babel/polyfill'
// import 'whatwg-fetch'

import { getDownloadUrl } from './components/Form/Block/renderFiles/fileRealServe'

/*
	appSettings的使用说明
	inited: 布尔值，表示是否已经获取配置,装载成功后同时置Tyan.appSettingsInited=true
	useMockData: 布尔值，表示是否使用模拟数据
	useMockWX: 布尔值，表示是否使用模拟微信环境
	fetchOrigin: postEvent的起点，主要用于调试时使用
	fetchPath: 字符串，postEvent的固定路径，如：'/Tyanlims'
	fetchEventInPath: 布尔值，表示是否将event作为postEvent时路径的一部分，当为false时，event将放入data中传输
	getTransformPath: 字符串，定义GET操作的中转地址，不定义、或为null、或为空字符串时表示不用中转
	getMockData: 动态加载MockData
*/

require('./tyanInit')

const appSettings = {
	inited: false,
	getMockData: null,
	fetchPath: "api/system",
	fetchEventInPath: true,
	config: {}    // 配置一些前台行为的参数，如toastTimeout等
}
Tyan.appSettings = appSettings

export const isAdaptToPhone = () => {
	return !(appSettings.adaptToPhone === false)
}


export const setLoginToken = (token) => {
	sessionStorage.token = token
}

export const cleanLoginToken = () => {
	sessionStorage.removeItem('token')
}

export const getLoginToken = () => (
	sessionStorage.token || null
)

export const getFileServerInfo = () => {
	return appSettings.fileServerInfo || {}
}

/**
 *  support 
 * 		exportFile({event, id, url, FID})
 * 		exportFile(event, id, url, FID)
 * 
 * @param {*} event 优先级为3
 * @param {*} id 优先级为3
 * @param {*} url 优先级为1
 * @param {*} FID 优先级为2
 */

export const exportFile = (event, id, url, FID, fileName) => {
	if (event && typeof event === 'object') {
		FID = event.FID
		url = event.url
		id = event.id
		fileName = event.fileName

		event = event.event
	}

	const a = document.createElement('a')
	a.target = "_blank"
	if (appSettings.useMockData)
		a.href = "/SHHL/resources/返回品调查表.pdf"
	else
		a.href = url
			? appSettings.fetchPath + '/' + url
			: FID
				? getDownloadUrl({ FID, downloadFileName: fileName })
				: "/Tyanlims/comm/DoGet?event=" + event + "&id=" + id
	fileName && (a.download = fileName)

	a.click()
}

export const wait = timeout => new Promise(resolve => setTimeout(resolve, timeout))

const getHeaders = () => {
	const token = getLoginToken()
	return (token && {
		'Content-Type': 'application/json; charset=utf-8',
		'Authorization': 'TS ' + token,
	}) || {
		'Content-Type': 'application/json; charset=utf-8',
	}
}

const fetchAppSettings = async () => {
	const response = await fetch(`resources/appSettings.config.json?${s4()}`, {
		method: 'GET',
		headers: getHeaders(),
	})
	if (!response.ok) {
		console.error('can\'t get appSettings.config')
	}
	const json = await response.json()
	Object.keys(json).forEach(o => appSettings[o] = json[o])

	!appSettings.tyanLimsBasePath && (appSettings.tyanLimsBasePath = appSettings.fetchPath.toLowerCase().replace('api/system', 'API/Forms/Auth.aspx'))

	appSettings.config = {
		toastTimeout: 2000,
		toastDelayRate: 100,
		debug: false,
		mockDelay: 10,
		mockDelayRandom: 10,
		mockDbCache: 'session',
		showFetchSpinner: true,
		fetchSpinnerDelay: 50,
		...(appSettings.config || {})
	}

	if (appSettings.useMockData || appSettings.useMockWX || appSettings.mockEvents) {
		const mod = await import(/* webpackChunkName: "chunks/mock/data" */ '../mockdata')
		appSettings.getMockData = mod.getMockData ? mod.getMockData : mod.default
	}

	appSettings.fileServerInfo && delete appSettings.fileServerInfo.useMockData
	let fsPathHead = appSettings.fetchPath
	!appSettings.fetchEventInPath && fsPathHead.toLowerCase().endsWith('/dopost')
		&& (fsPathHead = fsPathHead.substring(0, fsPathHead.length - 7))

	const fsInfo = appSettings.fileServerInfo = {
		useMockData: appSettings.useMockData,
		mockSpeed: 100000,
		fileUploadPath: `${appSettings.fetchOrigin || ''}${fsPathHead}/UploadFile`,
		fileDownloadPath: `${appSettings.fetchOrigin || ''}${fsPathHead}${appSettings.fetchEventInPath ? '/GetFile?FID=' : '/doGet?event=GetFile&FID='}`,
		fileDownloadFilePath: `${appSettings.fetchOrigin || ''}${fsPathHead}/DownloadFile/`,
		rtAttachmentUploadPath: `${appSettings.fetchOrigin || ''}${fsPathHead}/UploadRichTextAttachment`,
		rtAttachmentDownloadPath: `${appSettings.fetchOrigin || ''}${fsPathHead}${appSettings.fetchEventInPath ? '/GetRichTextAttachment?DP=' : '/doGet?event=GetRichTextAttachment&DP='}`,
		...(appSettings.fileServerInfo || {})
	}
	if (fsInfo.useMockData) {
		let mod = await import(/* webpackChunkName: "chunks/mock/fs" */ './mockUtility/mockFileServe')
		appSettings.fileServerInfo.upload = mod.upload
		appSettings.fileServerInfo.download = mod.download
		appSettings.fileServerInfo.getMockDownloadUrl = mod.getMockDownloadUrl
		// mod = await import(/*webpackChunkName:"chunks/mock/cap" */ './components/Form/Block/Captcha/mockCaptcha')
		// appSettings.fileServerInfo.getCaptcha = mod.getCaptcha
		// appSettings.fileServerInfo.checkCaptcha = mod.checkCaptcha
	}

	appSettings.inited = true
}

fetchAppSettings()

/**
 * showSpinner:
 * param:
 *  event:
 * 	sourceComponent:
 * 	showFetchSpinner:
 *  stamp
 * return:
 * 	function: hideSpinner
 */
const showSpinner = (() => {
	const noFetchSpinnerEvents = ['Login', 'AutoLogin', 'CheckManagerData']
	const componentStatuses = {}
	const componentDeals = {
		'button': {
			doRequest: (btn, status) => !btn.destroyed && btn.getIconCls() != 'x-fa fa-spinner fa-spin'
				&& (status.iconCls = btn.getIconCls(), btn.setIconCls('x-fa fa-spinner fa-spin')),
			doEnd: (btn, status) => !btn.destroyed && status.count <= 1
				&& btn.setIconCls(status.iconCls)
		}
	}
	let stamps = []
	let sourceComponents = []

	return (event, sourceComponent, showFetchSpinner, stamp) => {
		// 如果有stamp并重复，提示 "交易处理中，请稍后再试!"，
		if (stamp && stamps.includes(stamp)) {
			Ext.toast(Tyan.t("交易处理中，请稍后再试!"))
			return
			// 如果有sourceComponent并重复，"数据处理中，请不要重复提交!"
		} else if (sourceComponent && sourceComponents.includes(sourceComponent)) {
			Ext.toast(Tyan.t("数据处理中，请不要重复提交!"))
			return
		}

		stamp && stamps.push(stamp)
		sourceComponent && sourceComponents.push(sourceComponent)

		const dealComponent = componentDeals[sourceComponent && sourceComponent.xtype]
		sourceComponent && !dealComponent && console.info('sourceComponent do not have deal:', sourceComponent)
		if (dealComponent) {
			const id = sourceComponent.id
			const status = componentStatuses[id] = componentStatuses[id] || { count: 0 }
			status.count++
			dealComponent.doRequest(sourceComponent, status)
			// 返回hideSpinner
			return () => {
				stamp && (stamps = stamps.filter(o => o != stamp))
				sourceComponent && (sourceComponents = sourceComponents.filter(o => o != sourceComponent))
				dealComponent.doEnd(sourceComponent, status)
				--status.count == 0 && delete componentStatuses[id]
			}
		}

		showFetchSpinner = showFetchSpinner !== undefined ? showFetchSpinner : noFetchSpinnerEvents.includes(event) ? false : Tyan.appSettings.config.showFetchSpinner
		showFetchSpinner && Tyan.fetchBegin()

		// 返回hideSpinner
		return () => {
			stamp && (stamps = stamps.filter(o => o != stamp))
			sourceComponent && (sourceComponents = sourceComponents.filter(o => o != sourceComponent))
			showFetchSpinner && Tyan.fetchEnd()
		}
	}
})()

export const postEvent = eventInfo => dispatch => {
	let {
		event,
		data = {},
		receivedData = null,
		onRequest = null,
		onSuccess = null,
		onFailure = null,
		onEnd = null,
		fetchTimeMock = 0,
		isWXEvent = false,
		sourceComponent,
		stamp,
		showFetchSpinner
	} = eventInfo

	if (Tyan.sysMode === 'sample') {
		setTimeout(() => {
			const errorMessage = "原型系统 不可使用postEvent"
			onEnd && onEnd({ errorMessage })
			onFailure && onFailure({ errorMessage })
		})
		return
	}

	Tyan.pubControl.lastPostEvent = Date.now()

	if (!appSettings.inited || (appSettings.useMockData || appSettings.useMockWX || appSettings.mockEvents) && !appSettings.getMockData) {
		// console.error('appSettings.inited == false, event =', event)
		return wait(0).then(() => {
			return postEvent(eventInfo)(dispatch)
		})
	}

	const hideSpinner = showSpinner(event, sourceComponent, showFetchSpinner, stamp)
	if (!hideSpinner) return
	onRequest && onRequest()

	dispatch && dispatch({ type: `${event}/REQUEST`, data })
	return wait(fetchTimeMock).then(
		() => {
			return receivedData && Promise.resolve(receivedData) ||
				((appSettings.useMockData && !isWXEvent) || (appSettings.useMockWX && isWXEvent) || (appSettings.mockEvents || []).includes(event))
				? appSettings.getMockData({ event, data, token: getLoginToken() })
				: fetch((appSettings.fetchOrigin || ''/* document.location.origin */) + appSettings.fetchPath + (appSettings.fetchEventInPath && ('/' + event) || ''), {
					method: 'POST',
					headers: getHeaders(),
					body: JSON.stringify(appSettings.fetchEventInPath && data || { ...data, event })
				}).then(response => {
					if (response.ok)
						return response.json()
					if (response.status === 401) {
						// Ext.log({ indent: 1, level: 'error'})
						Tyan.locationControl.hashChangeHandler = null
						!location.hash.toLowerCase().includes('login') && (location.hash = '/Logout')
						return { errorMessage: Tyan.postErr['401'] }
					}
					return Promise.reject(`${response.status} - ${response.statusText}`)
				}).catch(error => {
					return Promise.reject(`通讯异常: ${error.toString()}`)
				})
		}
	).then(
		({ errorMessage, ...receivedData }) => {
			onEnd && onEnd({ errorMessage, ...receivedData })
			if (errorMessage) {
				onFailure && onFailure({ errorMessage, ...receivedData })
				dispatch && dispatch({ type: `${event}/FAILURE`, errorMessage, receivedData, data })
			} else {
				onSuccess && onSuccess(receivedData)
				dispatch && dispatch({ type: `${event}/SUCCESS`, receivedData, data })
			}
		},
		errorMessage => {
			onEnd && onEnd({ errorMessage })
			onFailure && onFailure({ errorMessage })
			dispatch && dispatch({ type: `${event}/FAILURE`, errorMessage, receivedData: {}, data })
		}
	).finally(() => {
		hideSpinner()
	})
}

const typesOfShowFile = [
	//  'pdf',
	'png',
	'jpg'
]

export const getUrl = (path) => {
	if (isBase64(path) || isWxResource(path)) return path
	if (appSettings.useMockData)
		return location.origin + (appSettings.getTransformPath || '') + path
	return (appSettings.fetchOrigin || location.origin) + (appSettings.getTransformPath || '') + path //非useMockData和useMockWX情况前端点击添加和后端有冲突
}

export const showFile = ({ path, ext }) => {
	if (!typesOfShowFile.includes(ext.toLowerCase())) {
		location.href = getUrl(path)
	} else {
		location.hash = '/QYWX/ShowFile/' + encodeURIComponent(path) + '/' + encodeURIComponent(ext.toLowerCase())
	}
}

export const genFileSizeDesc = (fileSize) => {
	var i = 0
	var byteUnits = [' B', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB']
	while (fileSize > 1024 && i < byteUnits.length - 1) {
		fileSize = fileSize / 1024
		i++
	}

	return Math.max(fileSize, 0.1).toFixed(1).replace('.0', '') + byteUnits[i]
}


export const validateEmail = email => {
	var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}

export const validatePassword = password => {
	var re = /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
	return re.test(String(password));
}

export function s4() {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1)
}

export function getUuid() {
	return s4() + s4() + s4() + s4()
}

Tyan.s4 = s4
Tyan.getUuid = getUuid

// 将一个数组转换成对象，数组中每个对象的[keyName]作为对象的属性名称。例如：
// const arr = [{name: "张三", age: 12}, {name: "李四", age: 13}]
// const obj = a2o(arr, 'name')
// obj = {张三: {age: 12}, 李四: {age: 13}}
export function a2o(arr, keyName, initObj = {}) {
	return arr.reduce((obj, item) => {
		const { [keyName]: key, ...rest } = item
		return { ...obj, [key]: rest }
	}, initObj)
}

// 将一个对象转换成数组，对象中属性的名称作为数组中每个对象的[keyName]属性的值。例如：
// const obj = {张三: {age: 12}, 李四: {age: 13}}
// const arr = o2a(obj, 'name')
// arr = [{name: "张三", age: 12}, {name: "李四", age: 13}]
export const o2a = (obj, keyName, initArr = []) => (
	initArr.concat(Object.entries(obj).map(([key, value]) => (
		{ ...value, [keyName]: key }
	)))
)

export function isIPhone() {
	return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
}

export function isAndroid() {
	return /(Android)/i.test(navigator.userAgent)
}

export function isWxResource(path) {
	return /(weixin:\/\/resourceid)/i.test(path) || /(img:\/\/\/storage\/)/i.test(path)
}

export function isBase64(path) {
	return /^data:image\/(jpg|jpeg|png|gif);base64,/g.test(path)
}

export const getQuery = (str, name) => {
	const s = `(\\?|\\&|#)${name}\\=(.*?)(\\&|$|#)`
	const re = new RegExp(s, "i")
	const result = re.exec(str)
	return result && result.length === 4 && result[2] || null
}

const syncUploadImage = ({ localIds, onChoosed }) => {
	var localId = localIds.shift()
	if (isIPhone()) {
		wx.getLocalImgData({
			localId: localId,
			success: (res) => {
				uploadImage({ localIds, file: res.localData, localId, onChoosed })
			}
		})
	} else {
		uploadImage({ localIds, file: localId, localId, onChoosed })
	}
}

const uploadImage = ({ localIds, file, localId, onChoosed }) => {
	if (!appSettings.useMockData) {
		wx.uploadImage({
			localId: localId,
			isShowProgressTips: 0,
			success: function (res) {
				onChoosed && onChoosed({ file: file, serverId: res.serverId })
				syncUploadImage({ localIds, onChoosed })
			}
		})
	} else {
		onChoosed && onChoosed({ file: file })
	}
}

class _WX {
	config = (param, onReady, onError) => {
		if (appSettings.useMockWX) {
			onReady && onReady()
		} else {
			wx.config(param)
			wx.ready(onReady)
			wx.error(onError)
		}
	}
	getLocation = (param) => {
		if (appSettings.useMockWX) {
			const { success } = param
			success && success({ latitude: 30.0, longitude: 120.0 })
		} else {
			wx.getLocation(param)
		}
	}

	chooseImage = (param) => {
		const { onChoosed, count } = param
		if (appSettings.useMockWX) {
			onChoosed && onChoosed({ file: 'resources/test2.png', path: 'resources/test2.png' })
		} else {
			wx.chooseImage({
				count: count ? count : 1,
				sizeType: ['original', 'compressed'],
				sourceType: ['album', 'camera'],
				success: function (res) {
					syncUploadImage({ localIds: res.localIds, onChoosed })
				}
			})
		}
	}

	scanQRCode = (param) => {
		const { onScaned, onCancel } = param
		if (appSettings.useMockWX) {
			onScaned && onScaned({ code: 'Y20170432' })
		} else {
			wx.scanQRCode({
				desc: 'scanQRCode desc',
				needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
				scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
				success: function (res) {
					// 回调
					onScaned && onScaned({ code: res.resultStr })
				},
				cancel: function () {
					// 取消回调
					onCancel && onCancel()
				},
				error: function (res) {
					if (res.errMsg.indexOf('function_not_exist') > 0) {
						alert('版本过低请升级')
					}
				}
			})
		}
	}

	startRecord = () => {
		if (appSettings.useMockWX) {
		} else {
			wx.startRecord()
		}
	}

	stopRecord = (param) => {
		const { onStoped } = param
		if (appSettings.useMockWX) {
			onStoped && onStoped({ localId: 'xxxx' })
		} else {
			wx.stopRecord({
				success: function (res) {
					// 回调
					onStoped && onStoped({ localId: res.localId })
				}
			})
		}
	}

	//录音时间超过一分钟没有停止的时候会执行 complete 回调
	onVoiceRecordEnd = (param) => {
		const { onRecordEnd } = param
		if (appSettings.useMockWX) {
			onRecordEnd && onRecordEnd({ localId: 'xxxx' })
		} else {
			wx.onVoiceRecordEnd({
				// 录音时间超过一分钟没有停止的时候会执行 complete 回调
				complete: function (res) {
					// 回调
					onRecordEnd && onRecordEnd({ localId: res.localId })
				}
			})
		}
	}

	playVoice = (param) => {
		const { localId } = param
		if (appSettings.useMockWX) {
		} else {
			wx.playVoice({
				localId: localId // 需要播放的音频的本地ID，由stopRecord接口获得
			})
		}
	}

	pauseVoice = (param) => {
		const { localId } = param
		if (appSettings.useMockWX) {
		} else {
			wx.pauseVoice({
				localId: localId // 需要播放的音频的本地ID，由stopRecord接口获得
			})
		}
	}

	stopVoice = (param) => {
		const { localId } = param
		if (appSettings.useMockWX) {
		} else {
			wx.stopVoice({
				localId: localId // 需要播放的音频的本地ID，由stopRecord接口获得
			})
		}
	}

	onVoicePlayEnd = (param) => {
		const { onPlayEnd } = param
		if (appSettings.useMockWX) {
			onPlayEnd && onPlayEnd({ localId: 'xxxx' })
		} else {
			wx.onVoicePlayEnd({
				success: function (res) {
					// 回调
					onPlayEnd && onPlayEnd({ localId: res.localId }) // 返回音频的本地ID
				}
			})
		}
	}

	uploadVoice = (param) => {
		const { onUpload, localId } = param
		if (appSettings.useMockWX) {
			onUpload && onUpload({ serverId: 'xxxx' })
		} else {
			wx.uploadVoice({
				localId, // 需要上传的音频的本地ID，由stopRecord接口获得
				isShowProgressTips: 1, // 默认为1，显示进度提示
				success: function (res) {
					onUpload && onUpload({ serverId: res.serverId }) // 返回音频的服务器端ID
				}
			})
		}
	}

	downloadVoice = (param) => {
		const { onDownload, serverId } = param
		if (appSettings.useMockWX) {
			onDownload && onDownload({ localId: 'xxxx' })
		} else {
			wx.downloadVoice({
				serverId, // 需要下载的音频的服务器端ID，由uploadVoice接口获得
				isShowProgressTips: 1, // 默认为1，显示进度提示
				success: function (res) {
					onDownload && onDownload({ localId: res.localId }) // 返回音频的本地ID
				}
			})
		}
	}
}

export const WX = new _WX


export const getFileIcon = (() => {
	const fileIcon = {
		'.xls': 'excel-o',
		'.xlsx': 'excel-o',
		'.doc': 'word-o',
		'.docx': 'word-o',
		'.rtf': 'word-o',
		'.ppt': 'powerpoint-o',
		'.pdf': 'pdf-o',
		'.jpg': 'image-o',
		'.jpeg': 'image-o',
		'.png': 'image-o',
		'.gif': 'image-o',
		'.mp3': 'audio-o',
		'.mp4': 'video',
		'.mov': 'video',
	}
	return ext => ext && fileIcon[ext.toLowerCase()] || 'archive-o'
})()

export const getFileType = (() => {
	const fileTypes = {
		'excel-o': 'Excel',
		'word-o': 'Word',
		'powerpoint-o': 'Powerpoint',
		'image-o': 'Image',
		// 'pdf-o': 'pdf',
		// 'audio-o': 'audio',
		// 'video': 'video',
	}

	return icon => fileTypes[icon]
})()

// 转换整数为AA格式，如Excel列号, n从1开始
const codeOfA = 'A'.charCodeAt(0)
export const intToAA = n => {
	let i = n
	let ret = ''

	while (i > 0) {
		ret = String.fromCharCode(codeOfA + ((i % 26) ? (i % 26) : 26) - 1) + ret
		i = Math.floor((i - 1) / 26)
	}
	return ret
}

// 转换整数索引为AA格式,
export const indexToAA = n => intToAA(n + 1)

// 转换AA格式为int格式，返回从1开始
export const aAToInt = str => {
	str = str.toUpperCase()
	let ret = 0
	const length = str.length
	for (let i = 0; i < length; i++)
		ret = ret * 26 + str.charCodeAt(i) - codeOfA + 1

	return ret
}
// 转换AA格式为index, 返回从0开始
export const aAToIndex = str => aAToInt(str) - 1

// [row, col] => 'AAnn' 从1开始
export const intToCellAddress = ([row, col]) => `${intToAA(col)}${row}`

// [row, col] => 'AAnn' 从0开始
export const indexToCellAddress = ([row, col]) => `${indexToAA(col)}${row + 1}`

export const intToCellRange = arr => arr.map(intToCellAddress).join(':')
export const indexToCellRange = arr => arr.map(indexToCellAddress).join(':')

// 'AAnn' => [row, col] 从1开始
export const cellAddressToInt = str => {
	str = str.split('!').pop()
	const [, col, row] = str.match(/^(.*?)(\d+)$/)
	return [parseInt(row), aAToInt(col)]
}

// 'AAnn' => [row, col] 从0开始
export const cellAddressToIndex = (...args) => cellAddressToInt(...args).map(o => o - 1)

export const cellRangeToInt = str => str.split(':').map(cellAddressToInt)
export const cellRangeToIndex = str => str.split(':').map(cellAddressToIndex)

export const str2utf8 = (str) => {
	var out, i, len, c
	out = ""
	len = str.length;
	for (i = 0; i < len; i++) {
		c = str.charCodeAt(i)
		if ((c >= 0x0001) && (c <= 0x007F)) {
			out += str.charAt(i)
		} else if (c > 0x07FF) {
			out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
			out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
			out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
		} else {
			out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
			out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
		}
	}
	return out
}

export const utf82str = (utf) => {
	var str = ""
	var tmp
	for (var i = 0; i < utf.length; i++) {
		// 英文字符集合
		if (utf.charCodeAt(i) >> 7 == 0x00) {
			str += utf.charAt(i)
			continue
		}
		// 其他字符集
		else if (utf.charCodeAt(i) >> 5 == 0x06) {
			tmp = ((utf.charCodeAt(i + 0) & 0x1f) << 6) |
				((utf.charCodeAt(i + 1) & 0x3f) << 0)
			str += String.fromCharCode(tmp)
			i++
			continue
		}
		// 中文字符集
		else if (utf.charCodeAt(i) >> 4 == 0x0e) {
			tmp = ((utf.charCodeAt(i + 0) & 0x0f) << 12) |
				((utf.charCodeAt(i + 1) & 0x3f) << 6) |
				((utf.charCodeAt(i + 2) & 0x3f) << 0)
			str += String.fromCharCode(tmp)
			i += 2
			continue
		}
		// 其他字符集
		else if (utf.charCodeAt(i) >> 3 == 0x1f) {
			tmp = ((utf.charCodeAt(i + 0) & 0x07) << 18) |
				((utf.charCodeAt(i + 1) & 0x3f) << 12) |
				((utf.charCodeAt(i + 2) & 0x3f) << 6)
					((utf.charCodeAt(i + 3) & 0x3f) << 0)
			str += String.fromCharCode(tmp)
			i += 3
			continue
		}
		// 非法字符集
		else {
			throw "不是UTF-8字符集"
		}
	}
	return str
}

Tyan.onReady(() => {
	Tyan.utility.intToAA = intToAA
	Tyan.utility.indexToAA = indexToAA
	Tyan.utility.aAToInt = aAToInt
	Tyan.utility.aAToIndex = aAToIndex
	Tyan.utility.intToCellAddress = intToCellAddress
	Tyan.utility.indexToCellAddress = indexToCellAddress
	Tyan.utility.cellAddressToInt = cellAddressToInt
	Tyan.utility.cellAddressToIndex = cellAddressToIndex
	Tyan.utility.intToCellRange = intToCellRange
	Tyan.utility.indexToCellRange = indexToCellRange
	Tyan.utility.cellRangeToInt = cellRangeToInt
	Tyan.utility.cellRangeToIndex = cellRangeToIndex

	Tyan.utility.utf82str = utf82str
})